import { Fragment, useEffect, useMemo, useState } from "react";
import { Button } from 'components/ui';
import { useSelector } from "react-redux";
import { getMenus, getModule, getTenantIsInternal } from "store/userSlice";
import { Outlet, useLocation, useOutletContext } from "react-router-dom";
import TestCockpit from "assets/images/test-cockpit.png";
import sanitize from "helpers/sanitize";
import Link from "components/ui/Link";
import { useTranslation } from "translation/useTranslation";
import { isDbModule } from "helpers/module";

export default function Index() {
  const { helps } = useOutletContext();

  const { editableTranslate, editableTranslateString } = useTranslation();

  const location = useLocation();
  const { pathname } = location;

  const menus = useSelector(getMenus);

  const currentModule = useSelector(getModule);

  const isDbModuleActive = useMemo(() => {
    return isDbModule(currentModule);
  }, [currentModule]);

  const subMenus = useMemo(() => {
    if (menus) {
      for (let i = 0; i < menus.length; i++) {
        if (menus[i].path === '/evaluation-statistics') return menus[i].submenus.data;
      }
    }
    return [];
  }, [menus]);

  const overlay = <div className="position-relative w-fit-content">
    <img src={TestCockpit} className="w-100" style={{ marginLeft: '-10px', filter: 'opacity(0.6)', maxWidth: '1280px' }} />

    <div className="notes-overlay">
      <div className="notes-div">

        <h5>{editableTranslate('evaluation_statistics.notes_overlay_title', 'Achtung:')}</h5>
        <div className="clearfix">
          <span dangerouslySetInnerHTML={{ __html: sanitize(editableTranslateString('evaluation_statistics.notes_overlay_text_1')) }} />
          <Button variant="secondary" className="float-right" icon="bi-file-earmark-arrow-down" data-testid="export-button">{editableTranslate('global.export', 'Bericht/Export')}</Button>
        </div>
        <br />
        <div dangerouslySetInnerHTML={{ __html: sanitize(editableTranslateString('evaluation_statistics.notes_overlay_text_2')) }} />
        <br />
        <div dangerouslySetInnerHTML={{ __html: sanitize(editableTranslateString('evaluation_statistics.notes_overlay_text_3')) }} />
      </div>
    </div>
  </div>;

  return (
    <div className="row flex-nowrap">
      <div className="col-lg-auto col-md-3 section-col-left d-flex min-height-after-navbar">
        <div className="bg-white w-100 p-4 content-card">
          <ul className="sidebar-nav nav nav-pills flex-column sticky">
            {
              isDbModuleActive && <li className="nav-item text-big text-primary font-weight-bold pb-1">{editableTranslate('evaluation_statistics.active', 'Aktiv')}</li>
            }
            {
              subMenus.map((sub, i) => {
                return <Fragment key={i}>
                  {
                    (i === (isDbModuleActive ? 2 : 1)) && <li className="nav-item text-big text-primary font-weight-bold pt-3 pb-1">{editableTranslate('evaluation_statistics.example', 'Beispiel')}</li>
                  }
                  <li className="nav-item">
                    <Link data-testid={`nav-item-${sub.translation_key}`} to={sub.path} className={`nav-link ${pathname.includes(sub.path) ? 'active' : ''}`}>
                      <i className={`${sub.icon} pr-2`}></i> {editableTranslate(sub.translation_key, sub.display_name)}
                    </Link>
                  </li>
                </Fragment>;
              })
            }
          </ul>
        </div>
      </div>
      <Outlet context={{ helps, overlay }} />
    </div>
  );
}
